import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";


export class RoutesFiltersPanelCtrl implements IController {
  statuses?: any;
  branchIds?: any;
  serviceAreaIds?: any;
  agentIds?: any;
  agentSkills?: string[];
  resourceIds?: any;
  onFiltersChange: Function;

  constructor(private $mdPanel) {
  }


  hasNoFilters() {
    return !_.get(this.statuses, 'length') &&
      !_.get(this.branchIds, 'length') &&
      !_.get(this.serviceAreaIds, 'length') &&
      !_.get(this.agentIds, 'length') &&
      !_.get(this.agentSkills, 'length') &&
      !_.get(this.resourceIds, 'length');

  }

  onShowPanel($event) {
    const panelPosition = this.$mdPanel.newPanelPosition()
      .relativeTo($event.target)
      .addPanelPosition(
        this.$mdPanel.xPosition.OFFSET_END,
        this.$mdPanel.yPosition.ALIGN_TOPS // yPosition.BELOW
      );

    const panelAnimation = this.$mdPanel.newPanelAnimation()
      .openFrom($event)
      .duration(200)
      .closeTo('.routes-filters-btn')
      .withAnimation(this.$mdPanel.animation.FADE);

    var config = {
      locals: {
        data: {
          statuses: this.statuses || [],
          branchIds: this.branchIds || [],
          serviceAreaIds: this.serviceAreaIds || [],
          agentIds: this.agentIds || [],
          agentSkills: this.agentSkills || [],
          resourceIds: this.resourceIds || [],
          parentScope: this
        },
        onClose: this.onClosePanel
      },
      attachTo: angular.element(document.body),
      controller: DeliveriesPanelCtrl,
      controllerAs: 'ctrl',
      position: panelPosition,
      animation: panelAnimation,
      targetEvent: $event,
      templateUrl: 'app/modules/lean-planning/components/routes-filters-panel/template/panel-template.html',
      clickOutsideToClose: true,
      escapeToClose: true,
      focusOnOpen: true,
      zIndex: 80,
      onCloseSuccess: function (panel, reason) {
        panel.destroy();
      }
    };

    this.$mdPanel.open(config);
  }

  onClosePanel(filterConfig, parentScope) {
    parentScope.onFiltersChange({
      statuses: filterConfig.statuses,
      branchIds: filterConfig.branchIds,
      serviceAreaIds: filterConfig.serviceAreaIds,
      agentIds: filterConfig.agentIds,
      agentSkills: filterConfig.agentSkills,
      resourceIds: filterConfig.resourceIds
    })
  }
}


export class DeliveriesPanelCtrl implements IController {

  public siteId: any;
  public isDraft: any;
  public filterConfig: any;

  constructor(private mdPanelRef) {
    this.siteId = this.mdPanelRef.config.locals.data.siteId;
    this.isDraft = this.mdPanelRef.config.locals.data.isDraft;
    this.filterConfig = {
      statuses: this.mdPanelRef.config.locals.data.statuses,
      branchIds: this.mdPanelRef.config.locals.data.branchIds,
      serviceAreaIds: this.mdPanelRef.config.locals.data.serviceAreaIds,
      agentIds: this.mdPanelRef.config.locals.data.agentIds,
      agentSkills: this.mdPanelRef.config.locals.data.agentSkills,
      resourceIds: this.mdPanelRef.config.locals.data.resourceIds
    }
  }

  onChangeStatuses(selectedStatuses) {
    this.filterConfig.statuses = selectedStatuses;
  }

  onChangeBranchIds(selectedBranchIds) {
    this.filterConfig.branchIds = selectedBranchIds;
  }

  onChangeServiceAreasIds(serviceAreasIds) {
    this.filterConfig.serviceAreaIds = serviceAreasIds;
  }

  onChangeAgentIds(agentIds) {
    this.filterConfig.agentIds = agentIds;
  }

  onChangeSkills(skillsIds) {
    this.filterConfig.agentSkills = skillsIds;
  }

  onChangeResourceIds(resources) {
    this.filterConfig.resourceIds = _.map(resources, 'id');
  }

  onReset() {
    this.filterConfig = {
      statuses: [],
      branchIds: [],
      serviceAreaIds: [],
      agentIds: [],
      agentSkills: [],
      resourceIds: [],
      inRoute: undefined,
    };
    this.submit();
  }

  submit() {
    this.mdPanelRef.close().then((mdPanelRef) => {
      mdPanelRef.config.locals.onClose(this.filterConfig, this.mdPanelRef.config.locals.data.parentScope);
    })
  }

  cancel() {
    this.mdPanelRef.close();
  }


}


angular
  .module('bringoz.admin.lean-planning')
  .component('routesFiltersPanel', {
    bindings: {
      statuses: '<?',
      branchIds: '<?',
      serviceAreaIds: '<?',
      agentIds: '<?',
      agentSkills: '<?',
      resourceIds: '<?',
      onFiltersChange: '&'
    },
    template: require('./routes-filters-panel.html').default,
    controller: RoutesFiltersPanelCtrl
  });
